<!-- src/app/pages/dashboard/dashboard.component.html -->
<div [attr.data-condition]="(condition$ | async) || 'HTN'">
    <app-stats-card [cards]="null" [htn]="latestRunHtn" [rows]="latestRunRows" [runIndex]="latestRunIndex"
        [yearOverride]="yearOverride">
    </app-stats-card>
</div>

<app-analysis class="block mt-4 mb-4"></app-analysis>

<div class="mt-6 dashCostComponent">
    <app-dashboard-costmetrics></app-dashboard-costmetrics>
</div>